import { SUBDOMAINS } from './enums';

const domainsToClientId = {
  [SUBDOMAINS.MAIN]: 'RCL2021',
  [SUBDOMAINS.LOCALHOST]: 'RCL2021',
  [SUBDOMAINS.WINC]: 'Ni8XL5tsrUBY4',
  [SUBDOMAINS.ROSEBANKSC]: 'Ys7XL5tsrPA57',
  [SUBDOMAINS.JIS]: 'JIS2025',
  [SUBDOMAINS.HILLCRESTCC]: 'G4BnL5tsrKL2A',
  [SUBDOMAINS.STLAURENCE]: 'JHA6L5tsrSD97',
  [SUBDOMAINS.S_CROSS]: 'KBS345ts65ASVC',
  [SUBDOMAINS.BEAUDESERT]: 'DFVN32ts238F4',
  [SUBDOMAINS.ROCKHAMPTON]: 'TNM65tAR3HP7',
  [SUBDOMAINS.PGONLINE]: 'WQC65tWQJY75',
  [SUBDOMAINS.PRSPNE]: 'LDCW8tWQ34FB',
  [SUBDOMAINS.ISFWATERLOO]: 'NSWV3tW6G7WQ',
  [SUBDOMAINS.ALBANYSHS]: 'ASPV73D7V5G',
  [SUBDOMAINS.AVIATIONHIGH]: 'JS96Qts32SXP',
  [SUBDOMAINS.AVILACOLLEGE]: 'KDV5Sts14HS',
  [SUBDOMAINS.BILOELASHS]: 'AQCK5tsVTKS',
  [SUBDOMAINS.BSSSC]: 'BXCTRts67PSZ',
  [SUBDOMAINS.BUNDABERGSHS]: '34TGBt23XTG',
  [SUBDOMAINS.GYMPIESHS]: '74H6Ct23XD3',
  [SUBDOMAINS.MALANDASHS]: '34GBSt235SS',
  [SUBDOMAINS.MOSSMANSHS]: 'WSKG43D766S',
  [SUBDOMAINS.NAMBOURSC]: 'DOG4Pt23TSF',
  [SUBDOMAINS.NANANGOSHS]: '1SCTBt23B54',
  [SUBDOMAINS.PEDARECC]: 'BTHA23D7742',
  [SUBDOMAINS.PROSERPINESHS]: '32RTBt2365H',
  [SUBDOMAINS.REDBANKPLAINSSHS]: 'FGV45t2373RT',
  [SUBDOMAINS.SPRINGFIELDCENTRALSHS]: 'KND85t2373DN',
  [SUBDOMAINS.STJAMESCOLLEGE]: 'EWQ5t23797D',
  [SUBDOMAINS.SPCC]: 'D32G2372FB',
  [SUBDOMAINS.TANNUMSANDSSHS]: 'GAX32235RTS',
  [SUBDOMAINS.TCCR]: '43GBP23SV5T',
  [SUBDOMAINS.VPSHS]: '7FCTH23S37F',
  [SUBDOMAINS.WSSC]: '3FT6723DVBT',
  [SUBDOMAINS.WMYC]: 'WQBU63D7VB4',
  [SUBDOMAINS.WOODCRESTSC]: 'NMLS23D764',
  [SUBDOMAINS.YERONGASHS]: 'AXZ423D7649',
  [SUBDOMAINS.SUNCOASTCC]: '4FTH23D765D',
  [SUBDOMAINS.CHANCELLORSC]: 'D56H23D7D4F',
  [SUBDOMAINS.INDOOROOSHS]: 'zA3T6Yape5s',
  [SUBDOMAINS.STMARYSCOLLEGE]: 'QB4TMxxDNIT',
  [SUBDOMAINS.SAMPOERNAACADEMY]: '0O6IGdsajtZ',
  [SUBDOMAINS.ASPLEYSHS]: 'WHQ041V895O',
  [SUBDOMAINS.WARWICKSHSWA]: 'SXHT41V8977',
  [SUBDOMAINS.WYNNUMSHS]: 'WQBN41V89DT',
  [SUBDOMAINS.TRINITYBAYSHS]: 'K4ZQ8R2MLHW',
  [SUBDOMAINS.SISSCHOOLS]: 'DCNP84D3G7W',
  [SUBDOMAINS.CHARTERHOUSEALMATY]: 'KXPM7WQNR4J',
  [SUBDOMAINS.EMMAUS]: 'CRH3SWQ2V8H',
  [SUBDOMAINS.CALLIOPE]: '35DFA1V8PL4',
  [SUBDOMAINS.ATHERTON]: 'GHB4S1V8978',
  [SUBDOMAINS.PRONIN]: 'KDC5TARSCB4',
  [SUBDOMAINS.TRANSYLVANIA]: 'QIXWNEGVLPD',
  [SUBDOMAINS.VICTORYCOLLEGE]: 'FYCCLGYYQWX',
  [SUBDOMAINS.BMEZY]: 'APUEXUQHODR',
  [SUBDOMAINS.PERIDIS]: 'AQKUJHUYCNH',
  [SUBDOMAINS.CALVARY]: 'BAONMAYPQTO',
  [SUBDOMAINS.SCOTSPGC]: 'CFHKDSPKHBH',
  [SUBDOMAINS.IBID]: 'DFQAWCVAZFI',
  [SUBDOMAINS.SEVENSTEPS]: 'DKVSBVIGZVF',
  [SUBDOMAINS.DALBY]: 'EDVGIYPOZNT',
} as const;

export { domainsToClientId };
